import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { StoreProvider, createStore } from 'easy-peasy';

import Repairy from './containers/Repairy';
import model from './models/App.models';

import './App.css';

function App() {
	const store = createStore(model);
	return (
		<HelmetProvider>
			<StoreProvider store={store}>
				<BrowserRouter>
					<Repairy />
				</BrowserRouter>
			</StoreProvider>
		</HelmetProvider>
	);
}

export default App;
